import onlyPositiveNumber from "./onlyPositiveNumber"

const calculateTotalDeliveryFee = (
  discounts = [],
  deliveryFees,
  deliveryType
) => {
  if (deliveryFees === null) return {
    totalDeliveryFee: 0,
    totalDeliveryFeeBeforeDiscount: 0,
    totalDeliveryDiscountByCoupon: 0
  }

  const totalDeliveryFeeBeforeDiscount =
    deliveryFees?.fee || 0

  const totalDeliveryDiscountByCoupon =
    deliveryType === "delivery"
      ?
      discounts.reduce((t, discount) =>
        t += discount.deliveryDiscount, 0
      )
      : 0

  const totalDeliveryFee =
    onlyPositiveNumber(
      totalDeliveryFeeBeforeDiscount -
      totalDeliveryDiscountByCoupon
    )

  return {
    totalDeliveryFee,
    totalDeliveryFeeBeforeDiscount,
    totalDeliveryDiscountByCoupon
  }
}

export default calculateTotalDeliveryFee